module.exports = __webpack_public_path__ + "media/images/emblems/Boudry-coat_of_arms-2ec8111b387e0dbe038dd6833bf60fb5.svg";